<p-table
	[value]="paginationResult.entities"
	[lazy]="true"
	(onLazyLoad)="loadData($event)"
	[rows]="paginationRequest.pageSize"
	[totalRecords]="paginationResult.filteredEntities"
	[rowsPerPageOptions]="[10, 20, 30, 40, 50]"
	[paginator]="true"
	[(selection)]="selectedEntities"
	[loading]="loading"
	[rowHover]="true"
	[showCurrentPageReport]="true"
	dataKey="name"
	currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}"
	class="custom-table"
	styleClass="p-datatable-striped"
>
	<!-- #region TABLE TITLE DEFINITION -->
	<ng-template pTemplate="caption">
		<div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
			{{ 'tableManagement.cardConsumption.syncProcessLogs.title' | translate }}
		</div>
	</ng-template>
	<!-- #endregion TABLE TITLE DEFINITION -->

	<!-- #region TABLE COLUMN DEFINITION -->
	<ng-template pTemplate="header">
		<tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
			<!-- START DATE -->
			<th pSortableColumn="startDate">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center justify-content-center flex-fill h-100">
						{{ 'general.startDate' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="startDate"></p-sortIcon>
					</div>
				</div>
			</th>

			<!-- END DATE -->
			<th pSortableColumn="endDate">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center justify-content-center flex-fill h-100">
						{{ 'general.endDate' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="endDate"></p-sortIcon>
					</div>
				</div>
			</th>

			<!-- STATUS -->
			<th pSortableColumn="status">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center justify-content-center flex-fill h-100">
						{{ 'general.status' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="status"></p-sortIcon>
					</div>
				</div>
			</th>

			<!-- TOTAL PROCESSED -->
			<th pSortableColumn="totalProcessed">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardConsumption.syncProcessLogs.totalProcessed' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="totalProcessed"></p-sortIcon>
					</div>
				</div>
			</th>

			<!-- PROCESSED WITH ERRORS -->
			<th pSortableColumn="processedWithErrors">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardConsumption.syncProcessLogs.processedWithErrors' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="processedWithErrors"></p-sortIcon>
					</div>
				</div>
			</th>
		</tr>
	</ng-template>
	<!-- #endregion TABLE COLUMN DEFINITION -->

	<!-- #region TABLE BODY -->
	<ng-template pTemplate="body" let-entity>
		<tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editDialog(entity)">
			<!-- START DATE -->
			<td>{{ entity.startDate | date: 'dd/MM/yyyy HH:mm:ss' }}</td>

			<!-- END DATE -->
			<td>{{ entity.endDate | date: 'dd/MM/yyyy HH:mm:ss' }}</td>

			<!-- STATUS -->
			<td>{{ entity.status }}</td>

			<!-- TOTAL PROCESSED -->
			<td>{{ entity.totalProcessed }}</td>

			<!-- PROCESSED WITH ERRORS -->
			<td>{{ entity.processedWithErrors }}</td>
		</tr>
	</ng-template>
	<!-- #endregion TABLE BODY -->

	<!-- #region TABLE EMPTY MESSAGE -->
	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="5" class="p-0">
				<div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
					{{ 'table.tableEmptyMessage' | translate }}!
				</div>
			</td>
		</tr>
	</ng-template>
	<!-- #endregion TABLE EMPTY MESSAGE -->
</p-table>

<!-- ERRORS DIALOG -->
<p-dialog
	[(visible)]="showErrorDialog"
	[modal]="true"
	[style]="{ width: '90vw', height: '85vh' }"
	[draggable]="false"
	[resizable]="false"
	[header]="'tableManagement.cardConsumption.syncProcessLogs.errors' | translate"
>
	@if (showErrorDialog) {
		<app-sync-process-logs-error [selectedLog]="selectedLog"></app-sync-process-logs-error>
	}
</p-dialog>
